import { useLang } from "../i18n/LanguageContext";
import { GiKey, GiLockedChest, GiPadlock, GiWaxSeal } from "react-icons/gi";

const COPY = {
  pl: {
    eyebrow: "Sejf",
    title: "Dodatkowy klucz dla najbardziej osobistych snów",
    subtitle:
      "Konto chroni zwykłą Księgę Snów. Sejf jest opcjonalną warstwą dla wpisów i notatek, które użytkownik chce zamknąć mocniej — osobnym gestem odblokowania.",
    items: [
      "Nie blokuje zakładania konta",
      "Dotyczy tylko wybranych snów i notatek",
      "Ma jeden spójny przepływ odblokowania",
      "Zostaje częścią Pokoiku Morfeusza",
    ],
    status: "Sejf będzie częścią Pokoiku, nie obowiązkowym krokiem przy starcie.",
    label: "opcjonalna warstwa sejfu",
  },
  en: {
    eyebrow: "Vault",
    title: "An extra key for the most personal dreams",
    subtitle:
      "The account protects the ordinary Dream Codex. The Vault is an optional layer for entries and notes the user wants to lock more deliberately — with a separate unlock gesture.",
    items: [
      "Does not block account creation",
      "Applies only to selected dreams and notes",
      "Uses one consistent unlock flow",
      "Remains part of the Morpheus Room",
    ],
    status: "The Vault will be part of the Room, not a mandatory step at the start.",
    label: "optional vault layer",
  },
};

export const VaultSection = () => {
  const { lang } = useLang();
  const copy = COPY[lang] ?? COPY.pl;

  return (
    <section
      id="vault"
      className="parchment-texture py-24 md:py-32 border-y border-ink/10"
      data-ui="home-vault"
      data-testid="vault-section"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10" data-ui="home-vault-inner">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-5 ornate-frame bg-parchment-dark p-1" data-ui="home-vault-card">
            <div className="bg-parchment-dark p-10 md:p-12 text-center">
              <div className="flex justify-center text-gold-muted">
                <GiLockedChest className="text-6xl" />
              </div>
              <div className="divider-ornate mt-8 opacity-70">●</div>
              <div className="mt-8 grid gap-4 text-left">
                {copy.items.map((item, index) => (
                  <div
                    key={item}
                    className="flex items-start gap-3 font-body text-sm text-ink-soft leading-relaxed"
                    data-ui="home-vault-item"
                    data-testid={`vault-item-${index}`}
                  >
                    <GiWaxSeal className="text-gold-muted text-lg flex-shrink-0 mt-0.5" />
                    <span>{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="lg:col-span-7" data-ui="home-vault-copy">
            <span className="font-accent text-[11px] uppercase tracking-[0.3em] text-gold-muted">
              {copy.eyebrow}
            </span>
            <h2 className="font-heading italic text-4xl md:text-5xl text-ink mt-4 leading-tight">
              {copy.title}
            </h2>
            <p className="font-body text-base md:text-lg text-ink-soft mt-6 leading-relaxed max-w-2xl">
              {copy.subtitle}
            </p>
            <div className="mt-8 flex items-start gap-4 border border-gold-muted/40 bg-parchment p-6">
              <GiKey className="text-2xl text-gold-muted flex-shrink-0 mt-1" />
              <p className="font-body italic text-sm text-ink-soft leading-relaxed">
                {copy.status}
              </p>
            </div>
            <div className="mt-8 flex items-center gap-3 font-accent text-[10px] uppercase tracking-[0.25em] text-ink-soft">
              <GiPadlock className="text-gold-muted text-lg" />
              {copy.label}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
